<template>
<div id="introduction">
    <h1>LAM, Man Ho (Donald) 林文昊</h1>
    <h2>mhlam@link.cuhk.edu.hk</h2>
    <h2>Room 101, 1/F, Ho Sin-Hang Engineering Building, Sha Tin, Hong Kong</h2>

    <div class="profile_container">
        <div class="profile_avatar">
            <!-- Profile -->
            <img src="../../assets/img/avatar.jpg" width="80%" style="border-radius:20px" />

            <!-- Account list -->
            <div class="account">
                <a
                    class="account-item"
                    v-for="(a, index) in account"
                    :key="index"
                    :href="a.link"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <Icon :icon="a.icon" width="26" style="vertical-align:middle;" />
                </a>
            </div>

            <!-- Resume Button -->
            <div class="resume" @click="$store.commit('GO_STATIC', 'resume.pdf')">
                <a>Resume</a>
            </div>
        </div>

        <!-- Profile Description -->
        <div class="profile_description">
            <h3>Hello! I'm Donald.</h3>
            <p>
                I'm a second-year Ph.D. student in the
                <a href="https://www.cse.cuhk.edu.hk/">Computer Science and Engineering (CSE)</a>
                Department at
                <a href="https://www.cuhk.edu.hk/english/index.html">The Chinese University of Hong Kong (CUHK)</a>,
                advised by Prof.
                <a href="https://www.cse.cuhk.edu.hk/lyu/home">Michael R. Lyu</a>.
                My research focuses on Code Intelligence, with a particular emphasis on robustness evaluation of LLMs.
                I am broadly interested in understanding model reliability under perturbations, dynamic environments, and multi-agent collaboration.
                Prior to my Ph.D., I obtained my B.Sc. in Computer Science at CUHK in 2024 as a member of the
                <a href="https://www.erg.cuhk.edu.hk/erg/Elite">ELITE Stream</a>.
                My undergraduate thesis explored the psychology and decision-making of LLMs with Dr.
                <a href="https://penguinnnnn.github.io">Jen-tse Huang</a>, which laid the foundation for my current research direction.
            </p>
        </div>
    </div>
</div>
</template>

<script>
import { Icon } from '@iconify/vue2'

// ✅ Academicons
import semanticScholar from '@iconify-icons/academicons/semantic-scholar'
import googleScholar from '@iconify-icons/academicons/google-scholar'
import dblp from '@iconify-icons/academicons/dblp'
import github from '@iconify-icons/fa-brands/github'
import linkedin from '@iconify-icons/fa-brands/linkedin'
import xTwitter from '@iconify-icons/simple-icons/x'

export default {
  name: 'Introduction',
  components: { Icon },
  data() {
    return {
      account: [
        { title: 'GitHub', icon: github, link: 'https://github.com/DonaldLamNL' },
        { title: 'Google Scholar', icon: googleScholar, link: 'https://scholar.google.com/citations?hl=en&user=hOd8TtoAAAAJ&hl' },
        { title: 'Semantic Scholar', icon: semanticScholar, link: 'https://www.semanticscholar.org/author/Man-Ho-Lam/2218791687' },
        { title: 'DBLP', icon: dblp, link: 'https://dblp.org/pid/348/7056.html' },
        { title: 'X', icon: xTwitter, link: 'https://x.com/DonaldMHLam' },
        { title: 'LinkedIn', icon: linkedin, link: 'https://www.linkedin.com/in/man-ho-lam-17236126b/' },
      ],
    }
  },
}
</script>

<style scoped>
#introduction{
    position: relative;
    width: 1000px;
    height: 700px;
    margin: 50px auto;
    box-shadow: 0 0.3em 1em #000;
    overflow: scroll;
    text-align: center;
}
h1{
    font-size: 40px;
    line-height: 1.5;
    margin-top: 20px;
    font-weight: 500;
    font-family: 'Times New Roman', Times, serif;
}
h2{
    font-size: 20px;
    line-height: 1.5;
}
h3{
    font-size: 40px;
    line-height: 80px;
    font-family: "Brush Script MT", "Brush Script Std", "cursive";
    margin: 0 auto;
    display: inline;
}
.profile_container {
    margin-top: 50px;
    width: 100%;
    height: 500px;
    display: flex;
    align-items: flex-start;
}

.profile_avatar {
    width: 35%;
    border-radius: 10px;
    margin-right: 10px;
}

.profile_description {
    height: 100%;
    width: 60%;
    text-align: left;
    margin: 0;
}

p{    
    font-family: 'Titillium Web', Verdana, Helvetica, sans-serif;
    font-size: 18px;
    line-height: 1.5;
    font-weight: 400;
    margin-top: 10px;
}

.resume{
    display: block;
    width: fit-content;
    padding: 10px;
    margin: 0 auto;
    font-size: 20px;
    line-height: 1.5;
    border-radius: 10px;
    text-decoration: none;
    cursor: pointer;
}
.resume:hover{
    color: rgb(127, 129, 255);
}

/* account list styles */
.account{
    height: 50px;
    padding: 0 25px;
    text-align: center;
}
.account i{
    display: inline-block;
    height: 50px;
    width: 30px;
    line-height: 50px;
    font-size: 25px;
    text-align: center;
    color: rgb(24, 24, 24);
    margin: 0 10px;
    top: 0;
    position: relative;
}
.account i:hover{
    color: #2855c7;
}

a {
    text-decoration: none;
    color: #3670C9;
    cursor: pointer;
}

a:hover {
    color: #FF5733;
}

.account-item {
    /* line-height: 50px;
    display: inline-block;
    margin: 0 10px;
    color: #000; */
    transition: transform 0.2s, color 0.2s;
    display: inline-block;
    height: 50px;
    width: 30px;
    line-height: 50px;
    font-size: 25px;
    text-align: center;
    color: rgb(24, 24, 24);
    margin: 0 10px;
    top: 0;
    position: relative;
}
.account-item:hover {
    transform: scale(1.2);
    color: #007bff;
}
</style>
